import React from 'react';
import { compose, withState, lifecycle, withHandlers } from 'recompose';
import Iframe from 'react-iframe';
import ReactPlayer from 'react-player';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { withStyles } from '@material-ui/core/styles';
import Clear from '@material-ui/icons/Clear';

import Popup from '../Popup';
import { commonStyles, COLORS } from '../../styles/styles';
import { STATUSES } from '../../constants';
import { statusCode } from '../../utils';
import IframeComm from 'react-iframe-comm';
import {
  selectAssessment
} from '../../redux/reducers/userProgramsFull';
import {
  saveTimeTaken,
  addComponentStatusRequest,
  saveStatus,
} from '../../redux/reducers/addComponentStatus';

import {
  assignmentRequestRequest
} from '../../redux/reducers/assignmentRequest';

import PDFTron from '../PDFTron';

import {
  saveAnnotationRequest,
  selectAnnotationSave
} from '../../redux/reducers/annotations';
import { toggleViewAttach } from '../../redux/reducers/view';


const IframePopupAttach = ({
  classes,
  handlePopupToggle,
  pathToIframeFile,
  selectedContentItem,
  handleMessage,
  handlePauseVideo,
  saveStatus,
  handleUpdateStatus,
  handleFirstFail,
  handleAssignmentStatus,
  handleSaveAnnotations,
  handlePDFTRONSENDMessage,
  saveContent,
  user,
  submitMCQ,
  viewAssignment,
  selectedAttempt,
  getHTMLPath,
  handlePDFTRONMessage,
  toggleViewAttach
 
}) => (
  <div><Popup className="" >
    <div className="popupHolder">
      <div className="iframePopup">
      <div className={classes.popupHeader}>
          <Clear
            className={classes.closePopup}
            onClick={() => {
             
              toggleViewAttach(false)
            }}
          />
        </div>
        {console.log('ATTACH6',selectedContentItem)}
        <div className={classes.iframeContainer}>
      
      
          <IframeComm attributes={ {src: pathToIframeFile,
            width: "100%",
            height: "100%",
        }}
        
     />
         
        </div>
      </div>
    </div>
    
  </Popup>
  </div>
);

const styles = () => ({
  ...commonStyles,
  image: {
    margin: '0 auto',
    display: 'block',
    maxWidth: 1200,
    width: '98%',
  },
  iframeContainer: {
    position: 'relative',
    overflow: 'scroll',
    height: 'calc(100%)',
  },
  videoPopup: {
    width: '100%!important',
    height: '100%!important',
  },
  popupIframe: {
    boxShadow: '0 4px 5px 0 rgba(0,0,0,0.24)',
    width: '100%',
    height: '100%',
    position: 'relative',
    zIndex: 10,
  },
  popupHeader: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    backgroundColor:COLORS.cornerstoneDarkRed
  },
  closePopup: {
    color: '#fff',
    background: 'transparent',
    alignSelf: 'flex-end',
    cursor: 'pointer',
    margin: '10px 5px 0 0',
  },
});
const mapDispatchToProps = dispatch => ({
  selectAssessment: surveyId => dispatch(selectAssessment(surveyId)),
  toggleAddUserPopup: value => dispatch(toggleAddUserPopup(value)),
  toggleViewAttach: value => dispatch(toggleViewAttach(value)),
  addComponentStatusRequest: () => dispatch(addComponentStatusRequest()),
  saveStatus: status => dispatch(saveStatus(status)),
  toggleAddUserPopupSuccess: value => dispatch(toggleAddUserPopupSuccess(value)),
  assignmentRequestRequest: type => dispatch(assignmentRequestRequest(type)),
  selectAnnotationSave: json => dispatch(selectAnnotationSave(json)),
  saveAnnotationRequest: () => dispatch(saveAnnotationRequest()),
});

const mapStateToProps = state => ({
  user: state.loginReducer,
  submitMCQ: state.userProgramsFullReducer.submitMCQ,
  selectedAttempt: state.userProgramsFullReducer.selectedAttempt,
  viewAssignment: state.userProgramsFullReducer.viewAssignment,
});
export default compose(
  withState('statusComponent', 'handleChangeStatus', 0),
  withState('startTimePdf', 'handleSpentTimePdf', 0),
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  lifecycle({
    componentDidMount() {
      const {
        contentIframe,
        saveTimeTaken,
        saveStatus,
        selectedContentItem,
        addComponentStatusRequest,
        handleSpentTimePdf,
      } = this.props;
      if (contentIframe) {
        saveTimeTaken(0);
        if(selectedContentItem.type != 'Assignments'){
          saveStatus(statusCode(selectedContentItem.status));
         
          
          addComponentStatusRequest();
  
          handleSpentTimePdf(Date.now());
        }
        
      }
    },
    componentWillReceiveProps(nextProps) {
      const { addComponentStatus: thisAddComponentStatus, contentIframe } = this.props;
      const { addComponentStatus: nextAddComponentStatus, handleChangeStatus, status } = nextProps;

      if (contentIframe) {
        if (nextAddComponentStatus.status !== thisAddComponentStatus.status) {
          handleChangeStatus(status);
        }
      }
    },
    componentWillUnmount() {
      const {
        selectedContentItem: { type: contentType },
        contentIframe,
        saveStatus,
        saveTimeTaken,
        addComponentStatusRequest,
        startTimePdf,
      } = this.props;
      if (
        saveStatus &&
        (contentType === 'Image' ||
          contentType === 'jpg' ||
          contentType === 'png' ||
          contentType === 'Document')
      ) {
        saveStatus(STATUSES.completed.value);
      }
      if (contentIframe && contentType!='Assignments' && contentType!='Survey') {
        
        saveTimeTaken(Math.round((Date.now() - startTimePdf) / 1000));
        addComponentStatusRequest();
      }
    },
  }),
  withHandlers({
    handleUpdateStatus: props => e => {
      const { addComponentStatus, saveStatus, saveTimeTaken } = props;
      if (addComponentStatus.status !== STATUSES.completed.value) {
        saveStatus(STATUSES.inProgress.value);
      }
      saveTimeTaken(Math.round(e.playedSeconds / 1000));
    },
    getHTMLPath: props => path => {
      var p = path.split('.zip')
      return p[0]+'/index.html'
    },
    handlePDFTRONMessage: props => e => {
    
      var obj = JSON.parse(e.data)
      
      
      props.selectAnnotationSave(obj.annotations)
      props.saveAnnotationRequest()
      props.handlePopupToggle(props.selectedContentItem);
    },
    handlePDFTRONSENDMessage: props => e => {
      
      this.ifr.sendMessage('save', "*")
    },
    handleMessage: props => e => {
      const { addComponentStatusRequest, saveStatus, saveTimeTaken, handleAssignmentStatus, selectedContentItem, submitMCQ, assignmentRequestRequest, selectAssessent } = props;
      
    try {
      var msg = JSON.parse(e.data);
    
      if(msg.action==='STATUS'){
       
        if(msg.status==='ready' && selectedContentItem.status !== 'ready'){
         
          handleAssignmentStatus(msg.status);
        }else if(msg.status==='completed' && selectedContentItem.status !== 'completed'){
          if(msg.result.passed=='NYC'){
            if(selectedContentItem.attempts.length==0){
              if(submitMCQ==true){
                
                selectAssessment(selectedContentItem.survey_id);
                // selectUserAssessment(content.survey_id);
                assignmentRequestRequest('retake');
               
                 saveStatus(STATUSES.resubmission_request.value);
                // addComponentStatusRequest();
              }
            
            }else{
             
              handleAssignmentStatus('submitted');
            }
          
          }else{
            handleAssignmentStatus('completed');
          }
         
         
        }else if(msg.status==='in progress' && (selectedContentItem.status !== 'in progress' || selectedContentItem.status !== 'ready')){
          
          handleAssignmentStatus(msg.status);
          
        }else if(msg.status==='marking' && (selectedContentItem.status !== 'marking')){
          
          handleAssignmentStatus(msg.status);
          
        }else if(msg.status==='completed' && (selectedContentItem.status !== 'marking')){
          
          handleAssignmentStatus(msg.status);
          
        }
        
        
      }else if(msg.status==='completed' && (selectedContentItem.status !== 'marking')){
        
        handleAssignmentStatus(msg.status);
        
      }else if(msg.status==='in progress' && (selectedContentItem.status !== 'in progress' || selectedContentItem.status !== 'ready')){
        
        handleAssignmentStatus(msg.status);
        
      }
    } catch (error) {
      
    }
     
    },
  }),
  withStyles(styles),
)(IframePopupAttach);

IframePopupAttach.propTypes = {
  classes: PropTypes.instanceOf(Object),
  selectedContentItem: PropTypes.instanceOf(Object),
  handlePopupToggle: PropTypes.func,
  handlePauseVideo: PropTypes.func,
  handleUpdateStatus: PropTypes.func,
  saveStatus: PropTypes.func,
  pathToIframeFile: PropTypes.string,
};



// WEBPACK FOOTER //
// ./src/Components/Popups/IframePopupAttach.jsx